// Wam Facade with a Promise Interface
import auth from '../../utils/wam';

/**
 * Wrapper wam in a Promise and add the currentUser to the app props
 * @return {Promise}
 */
export default function setup() {
  return auth();
}
